import axios from "axios";
import router from "../router";
import { Loading } from "element-ui";
import { Message } from "element-ui";
//定义变量
let loading;
//定义开始加载函数
function startLoading() {
  //创建loading实例
  loading = Loading.service({
    lock: true,
    text: "拼命加载中...",
    background: "rgba(0,0,0,0.8)",
  });
}
//定义关闭加载函数
function endLoading() {
  // 增加判断：只有loading实例存在时才关闭，避免报错
  if (loading) {
    loading.close();
    // 关闭后重置loading变量，防止重复关闭
    loading = null;
  }
}
let reqUrl = "https://xcx.fawuxitong.com";
// 创建一个 Axios 实例
const service = axios.create({
  baseURL: reqUrl, // 接口的基础路径
  headers: {
    "Content-type": "application/x-www-form-urlencoded",
  },
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 判断config中showLoading是否为true（默认true），是则显示loading
    if (config.showLoading !== false) {
      startLoading();
    }
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    // 请求失败也需要关闭loading
    endLoading();
    console.error(error);
    return Promise.reject(error);
  },
);
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 核心修改：只有请求配置中showLoading为true时，才关闭loading
    if (response.config.showLoading !== false) {
      endLoading();
    }
    if (response.data.code == 401) {
      Message({ message: "登录过期，即将重新登录", type: "error" });
      sessionStorage.clear();
      router.push("/login");
    }

    return response.data;
  },
  (error) => {
    // 处理响应错误
    // message('请求数据失败','error')
    endLoading();
    console.log(error);
  },
);
export const request = service;
export { reqUrl };

// 上传到本地接口地址
export const uploadUrl = `${reqUrl}${process.env.VUE_APP_UPLOAD_URL}?local=1`;